<div
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [infiniteScrollContainer]="infiniteScrollContainer"
  [fromRoot]="true"
  [scrollWindow]="true"
  (scrolled)="onScrollDown()"
>
  <div [class]="containerClasses" [ngClass]="columns">
    <ng-container *ngFor="let item of items">
      <div class="ui column">
        <gd-product-templates-list-item
          [item]="item"
          [showEditButton]="showEditButton"
          [showActionButtons]="showActionButtons"
          [showPlaceOrderButton]="showPlaceOrderButton"
          (placeOrderButtonClick)="onPlaceOrderButtonClick(item)"
          (addToStoreButtonClick)="onAddToStoreButtonClick(item)"
          (editButtonClick)="onEditButtonClick(item)"
          (renameButtonClick)="onRenameButtonClick(item)"
          (duplicateButtonClick)="onDuplicateButtonClick(item)"
          (deleteButtonClick)="onDeleteButtonClick(item)"
          (itemClick)="itemClick.emit(item)"
        >
        </gd-product-templates-list-item>
      </div>
    </ng-container>
  </div>
</div>
